import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
	status: string;
	className?: string;
}

const FormatResourceStatus = (props: Props) => {
	let labelClass = "";
	const { t } = useTranslation();
	switch (props.status) {
		case "OPENED":
		case "STARTED":
		case "OPEN":
		case "OCCURRING":
		case "NEW":
			labelClass = "bg-primary";
			break;
		case "PAID":
		case "ACTIVE":
		case "HIRED":
		case "ENABLED":
		case "SUCCESS":
		case "FINISHED":
		case "RECOMMENDED":
		case "CONFIRMED":
			labelClass = "bg-success";
			break;
		case "VOIDED":
		case "WAITING":
		case "TO_CANCEL":
		case "ARCHIVED":
			labelClass = "bg-secondary";
			break;
		case "WAITING_PAYMENT":
		case "SKIPPED":
		case "EXTERNAL":
		case "PROGRESS":
		case "IN_TRIAL":
			labelClass = "bg-warning text-dark";
			break;
		case "INACTIVE":
		case "FIRED":
		case "DELETED":
		case "DISABLED":
		case "REMOVED":
		case "FAILURE":
		case "ERROR":
		case "NOT_PAID":
		case "PAYMENT_DUE":
		case "NON_RENEWING":
		case "CANCELLED":
		case "EXPIRED":
		case "BLOCKED":
		case "DENIED":
		case "CLOSED":
			labelClass = "bg-danger";
			break;
		case "PAUSED":
			labelClass = "bg-transparent border border-dark text-dark";
			break;
		default:
			labelClass = "bg-primary";
			break;
	}

	return (
		<span className={`badge ${labelClass} ${props.className ? props.className : ""}`}>
			{t(`enums.common.status.${props.status}`, { ns: ["translation", "lib"] })}
		</span>
	);
};

export default FormatResourceStatus;
